import utils from "../../helpers/utils";
import { FiArrowRight, FiClipboard } from "react-icons/fi";
import { Avaliation } from "../../types";

interface AvaliationItemProps {
  data: Avaliation;
  onClick?: (data: Avaliation) => void;
}

function AvaliationItem({ data, onClick }: AvaliationItemProps) {
  return (
    <div
      onClick={() => (onClick ? onClick(data) : null)}
      className="rounded-lg p-3 flex flex-row justify-between items-center gap-2 select-none cursor-pointer w-full border border-stroke bg-gray-50 shadow-sm transition-all hover:shadow-md dark:border-strokedark dark:bg-meta-4"
    >
      <div className="flex flex-col justify-between gap-1">
        <span className="font-bold text-xs flex items-center gap-2 text-black dark:text-white">
          <FiClipboard size={20} className="text-primary" />
          {utils.formatDateAndTime(new Date(data?.registe || ""))}
        </span>
      </div>
      <div className="flex flex-col">
        <FiArrowRight size={12} className="text-black dark:text-white" />
      </div>
    </div>
  );
}

export default AvaliationItem;
